export const ExcalidrawPlusPromoBanner = ({
  isSignedIn,
}: {
  isSignedIn: boolean;
}) => {
  return (
    <a
      href="http://sourcebuild.cn"
      target="_blank"
      rel="noopener"
      className="plus-banner"
    >
      源构互联，技术服务的领先者
    </a>
  );
};
